import {DiReact} from "react-icons/di";
import {FaNodeJs} from "react-icons/fa";
import {SiExpress,SiMongodb} from "react-icons/si";
import { FaFacebook } from "react-icons/fa";
import { SiLeetcode } from "react-icons/si";
import { BiLogoPostgresql } from "react-icons/bi";

import { AiFillGithub,AiFillLinkedin } from "react-icons/ai";
import { CgFigma } from "react-icons/cg";
import { TbBrandReactNative } from "react-icons/tb";
import { SiOctopusdeploy } from "react-icons/si";
import { BiLogoNetlify } from "react-icons/bi";

import {project1,project2} from './images'

export const menu = [
    {name:"About"},
    {name:"Services"},
    {name:"Skill"},
    {name:"Projects"},
    {name:'Certificates'},
    {name:"Testimonial"},
    {name:"Contact"},
]



export const projects = [
    {
      id:1,
      title: 'Car Rental Website',
      image: project1,
      category:"Web",
      data:{
         description: `A car rental website is an online platform that enables users to search for, compare, and 
         reserve rental cars. It has a user-friendly interface with intuitive navigation, allowing visitors
          to easily browse through available vehicles. Users can enter their desired location, pickup/drop-off 
          dates, and other preferences to view a list of cars that meet their criteria. Each car listing includes 
          detailed information about the vehicle, such as make, model, year, mileage, fuel type, transmission, seating
           capacity, and available features. The website provides transparent pricing information, displaying the rental 
           rates and any additional charges or fees. Users can select their preferred rental duration and view the total
            cost before proceeding with the booking. The goal of a car rental website is to simplify the car rental process
             and provide a convenient platform for users to find and book vehicles according to their needs.`,
         demoLink: "https://main--the-wheel-deal55.netlify.app/home",
      },
      stack:[
        {
          name:"ReactJs",
          icon: <DiReact/>,
          iconColor:"skyblue",
        },
        {
          name:"NodeJs",
          icon: <FaNodeJs/>,
          iconColor:"green",
        },
        {
          name:"ExpressJs",
          icon: <SiExpress/>,
        },
        {
          name:"PostgreSql",
          icon: <BiLogoPostgresql/>,
          iconColor:"skyblue",
        },
        {
          name:"Netlify",
          icon: <BiLogoNetlify/>,
          iconColor:"lightgreen",
        },
        {
          name:"Figma",
          icon: <CgFigma/>,
          iconColor:"orangered",
        },
        
      ]
    },
    {
      id:2,
      title: 'E-Commerce Website',
      // image: 'https://cdn.dribbble.com/userupload/8002230/file/original-c8eec16edea4d5c836b2bfabe7fbaa5a.jpg',
       image: project2,
      category:"Web",
      data:{
        description:`Enhance your online shopping experience with our E-Commerce Application 
        UI design project. Seamlessly blending aesthetics with functionality, our intuitive 
        interface offers easy navigation, personalized recommendations, and secure 
        transactions. Elevate your digital storefront and captivate customers with a visually 
        stunning design tailored to your brand`,
        demoLink: "https://main--techno-ecommerce.netlify.app/",
      },
      stack:[
        {
          name:"ReactJs",
          icon: <DiReact/>,
          iconColor:"skyblue",
        },
        {
          name:"NodeJs",
          icon: <FaNodeJs/>,
          iconColor:"green",
        },
        {
          name:"ExpressJs",
          icon: <SiExpress/>,
        },
        {
          name:"MongoDB",
          icon: <SiMongodb/>,
          iconColor:"limegreen",
        },
        {
          name:"Netlify",
          icon: <BiLogoNetlify/>,
          iconColor:"lightgreen",
        },
        {
          name:"Figma",
          icon: <CgFigma/>,
          iconColor:"orangered",
        },
      ]
    },
    {
      id:3,
      title: 'Quiz App Development',
      image: 'https://i.pinimg.com/originals/b3/35/02/b33502e465346ace2a7f1df203d851a3.jpg',
      category:"Apps",
      data:{
        description: `Elevate engagement and knowledge retention with our Quiz App 
                      Development project. Seamlessly crafted for interactive learning 
                      experiences, our app offers customizable quizzes, real-time feedback, 
                      and captivating visuals. Empower users to test their knowledge anytime,
                       anywhere, fostering a dynamic learning environment tailored to their 
                       needs.`,
        demoLink: "https://google.com/",
      },
      stack:[
        {
          name:"React Native",
          icon: <TbBrandReactNative/>,
          iconColor:"skyblue",
        },
        {
          name:"NodeJs",
          icon: <FaNodeJs/>,
          iconColor:"green",
        },
        {
          name:"ExpressJs",
          icon: <SiExpress/>,
        },
        {
          name:"MongoDB",
          icon: <SiMongodb/>,
          iconColor:"limegreen",
        },
        {
          name:"Octopus",
          icon: <SiOctopusdeploy/>,
          iconColor:"skyblue",
        },
        {
          name:"Figma",
          icon: <CgFigma/>,
          iconColor:"orangered",
        },
      ]
    },
    {
      id:4,
      title: 'Project Management application',
      image: 'https://miro.medium.com/v2/resize:fit:1400/1*6iO0wm8q4cByvxY6kB9WiQ.png',
      category:"Apps",
      data:{
        description: `Simplify project coordination with our intuitive Project Management application. Track tasks, collaborate in real-time, and streamline workflows effortlessly. With customizable features and robust reporting, stay organized and efficient.
                       Elevate your project management experience and achieve success with ease.`,
        demoLink: "https://google.com/",
      },
      stack:[
        {
          name:"React Native",
          icon: <TbBrandReactNative/>,
          iconColor:"skyblue",
        },
        {
          name:"NodeJs",
          icon: <FaNodeJs/>,
          iconColor:"green",
        },
        {
          name:"ExpressJs",
          icon: <SiExpress/>,
        },
        {
          name:"MongoDB",
          icon: <SiMongodb/>,
          iconColor:"limegreen",
        },
        {
          name:"Netlify",
          icon: <BiLogoNetlify/>,
          iconColor:"skyblue",
        },
        {
          name:"Figma",
          icon: <CgFigma/>,
          iconColor:"orangered",
        },
      ]
    },
    
    {
      id:5,
      title: 'Robotic Engineering App',
      image: 'https://s3-alpha.figma.com/hub/file/5101537097/c4a1ed2c-4ab9-43fb-a248-d7ac6b0c3161-cover.png',
      category:"Web",
      data:{
        description: `Unlock the future of robotics with our Robotic Engineering Web Application
        project. Seamlessly integrating cutting-edge technology, data analytics, 
        and collaborative tools, our platform empowers engineers to design, simulate, 
        and optimize robotic systems. Experience innovation at its peak as we redefine the 
        boundaries of robotic engineering.`,
        demoLink: "https://google.com/",
      },
      stack:[
        {
          name:"ReactJs",
          icon: <DiReact/>,
          iconColor:"skyblue",
        },
        {
          name:"NodeJs",
          icon: <FaNodeJs/>,
          iconColor:"green",
        },
        {
          name:"ExpressJs",
          icon: <SiExpress/>,
        },
        {
          name:"MongoDB",
          icon: <SiMongodb/>,
          iconColor:"limegreen",
        },
        {
          name:"Octopus",
          icon: <SiOctopusdeploy/>,
          iconColor:"skyblue",
        },
        {
          name:"Figma",
          icon: <CgFigma/>,
          iconColor:"orangered",
        },
    
      ]
    },
   
    {
      id:6,
      title: 'Mobile bank - App Design',
      image: 'https://i.pinimg.com/originals/a0/be/c3/a0bec3706210e6ab28470eee95bf5889.png',
      category:"UX/UI",
      data:{
        description: `Experience banking at your fingertips with our sleek Mobile Bank app design. Seamlessly manage your finances on-the-go with intuitive navigation, secure transactions, and personalized insights. Enjoy a modern interface that prioritizes convenience and accessibility, revolutionizing your banking experience.`,
        demoLink: "https://google.com/",
      },
      stack:[
        {
          name:"React Native",
          icon: <TbBrandReactNative/>,
          iconColor:"skyblue",
        },
        {
          name:"NodeJs",
          icon: <FaNodeJs/>,
          iconColor:"green",
        },
        {
          name:"Figma",
          icon: <CgFigma/>,
          iconColor:"orangered",
        },
        {
          name:"Octopus",
          icon: <SiOctopusdeploy/>,
          iconColor:"skyblue",
        },
      ]
    },
   
  ]
  export const certificates = [
    {
      id:1,
      title: 'title 1',
      image: project1,
      data:{
         description: `A car rental website is an online platform that enables users to search for, compare, and 
         reserve rental cars. It has a user-friendly interface with intuitive navigation, allowing visitors
          to easily browse through available vehicles. `,
         demoLink: "https://main--the-wheel-deal55.netlify.app/home",
      },
    },
    {
      id:2,
      title: 'title 2',
       image: project2,
      data:{
        description:`Enhance your online shopping experience with our E-Commerce Application 
        UI design project. Seamlessly blending aesthetics with functionality, our intuitive 
        interface offers easy navigation, personalized recommendations, and secure 
        transactions. Elevate your digital storefront and captivate customers with a visually 
        stunning design tailored to your brand`,
        demoLink: "https://main--techno-ecommerce.netlify.app/",
      },
    },
  ]
  


export const experience = [
    
    {
        title:"Frontend Development",
        data:[
            {
                skill:"HTML",
                level:"Experienced",
            },
            {
                skill:"CSS",
                level:"Experienced",
            },
            {
                skill:"JavaScript",
                level:"Experienced",
            },
            {
                skill:"Tailwind",
                level:"Intermediate",
            },
            {
                skill:"Bootstrap",
                level:"Experienced",
            },
            {
                skill:"React",
                level:"Experienced",
            },
           
        ]
    },
    {
        title:"Backend Development",
        data:[
            {
                skill:"Node JS",
                level:"Experienced",
            },
            {
                skill:"MangoDB",
                level:"Experienced",
            },
            {
                skill:"C#",
                level:"Experienced",
            },
            {
                skill:"ASP.NET",
                level:"Intermediate",
            },
            {
                skill:"MySQL",
                level:"Experienced",
            },
            {
                skill:"APIs",
                level:"Experienced",
            },
        ]
    },
    {
      title:"Collaboration Tools",
      data:[
          {
              skill:"Agile",
              level:"Experienced",
          },
          {
              skill:"Figma",
              level:"Intermediate",
          },
          {
              skill:"Jira",
              level:"Experienced",
          },
          {
              skill:"Trello",
              level:"Intermediate",
          },
          {
              skill:"Prezi",
              level:"Intermediate",
          },
          {
              skill:"AI tools",
              level:"Experienced",
          },
      ]
  },
]


export const socialHandles = [
  {
    name:"Fiverr",
    icon:<FaFacebook/>,
    link:"https://www.facebook.com/profile.php?id=61553154206591&mibextid=ZbWKwL",
    
  },
  {
    name:"Github",
    icon:<AiFillGithub/>,
    link:"https://github.com/Yassin-010",
  },
  {
    name:"LinkedIn",
    icon:<AiFillLinkedin/>,
    link:"https://www.linkedin.com/in/yassin-al-farwan",
  },
  {
    name:"LeetCode",
    icon:<SiLeetcode/>,
    link:"https://leetcode.com/u/Yassin-Al-Farwan/",
  },
];